import React from 'react'
import { connect } from 'react-redux'
import PrecisionRound from '../../Utils/PrecisionRound'
import MarkupActions from '../../Redux/MarkupRedux'

class PriceComparison extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: false,
      form: {
        test_value: PrecisionRound((props.detail.test_value - 1) * 100)
      }
    }
  }

  _save = (event) => {
    event.preventDefault()
    const data = {
      id: this.props.detail.id,
      form: {
        test_value: (this.state.form.test_value / 100) + 1
      }
    }

    this.props.updateMarkup(data)
    this.props.closeModal()
  }

  _valueChange = (event) => {
    let val = event.target.value
    if (parseFloat(val) > 100) {
      val = 100
    } else if (parseFloat(val) < -100) {
      val = -100
    }
    let form = { ...this.state.form }
    form.test_value = val
    this.setState({ form })
  }

  render () {
    return (
      <div className='section' style={{ width: '35vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Change Predictive Value</h4>
        </div>
        <form onSubmit={(event) => this._save(event)}>
          <div className='form-group'>
            <label className='control-label'>Predictive Value</label>
            <div className='input-group' >
              <input type='number' required step='any' max={100} className='form-control' value={this.state.form.test_value} onChange={(event) => this._valueChange(event)} />
              <div className='input-group-append'>
                <span className='input-group-text'>%</span>
              </div>
            </div>
          </div>
          <div className='form-group text-right'>
            <button type='button' className='btn btn-secondary' onClick={() => this.props.closeModal()}>Cancel</button>
            <button type='submit' className='btn btn-primary ml-2'>Save</button>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  updateMarkup: (data) => dispatch(MarkupActions.markupUpdateRequest(data))
})

export default connect(stateToProps, dispatchToProps)(PriceComparison)



// WEBPACK FOOTER //
// ./src/Containers/Markup/PriceComparison.js